import {Model} from "ords/dist/model/model";

export class Rubric extends Model {

    hasSections() {
        return !!this.rubric_sections.length;
    }

    hasColumns() {
        if(this.hasSections()){
            for(const section of this.rubric_sections){
                if(section.rubric_columns.length >= 1){
                    return true;
                }
            }
        }

        return false;
    }

    hasRows() {
        if(this.hasSections()){
            for(const section of this.rubric_sections){
                if(section.rubric_rows.length >= 1){
                    return true;
                }
            }
        }

        return false;
    }
}

export const RubricModelConfig = {
    name: 'rubric',
    model: Rubric,
    relations : [
        {name: 'rubric_sections', model_name: 'rubricSection', type: 'hasMany'},
        {name: 'forms', model_name: 'rubricForm', type: 'hasMany'},
    ]
}
